import * as React from 'react';
import { SVGProps } from 'react';

export const DropBoxSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M12 6.17 6.5 9.712l5.5 3.5-5.5 3.5L1 13.17l5.5-3.5L1 6.17l5.5-3.5 5.5 3.5ZM6.5 17.837l5.5-3.542 5.5 3.542-5.5 3.5-5.5-3.5ZM12 13.17l5.5-3.5-5.5-3.5 5.5-3.5 5.5 3.5-5.5 3.542 5.5 3.5-5.5 3.5L12 13.17Z"
            fill="currentColor"
        />
    </svg>
);

export const GoogleDriveSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M15.62 14.37 9.031 3H15.5l6.59 11.37h-6.47Zm-5.544.965L6.82 21h12.496l3.254-5.665H10.076ZM8.187 4.446 2 15.335 5.214 21l6.308-10.888-3.335-5.666Z"
            fill="currentColor"
        />
    </svg>
);

export const PixabaySVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m15.605 12.37 1.922 2.46h2.117l-3.137-3.862 2.871-3.685h-1.991l-1.76 2.304-1.58-2.304h-2.005l2.641 3.685-2.872 3.862h2.069l1.725-2.46ZM7.994 7.287c-1.059.026-1.939.393-2.64 1.1-.7.706-1.063 1.593-1.09 2.661v6.801h1.482v-3.023h2.248c1.06-.027 1.942-.396 2.647-1.108.706-.711 1.072-1.601 1.1-2.67-.028-1.068-.394-1.955-1.1-2.661-.705-.707-1.588-1.074-2.647-1.1Zm-2.248 6.045v-2.284c.016-.645.234-1.18.656-1.606.421-.425.952-.645 1.592-.66.648.015 1.183.235 1.607.66.423.425.642.96.657 1.606-.015.654-.234 1.194-.657 1.62-.424.427-.96.649-1.607.664H5.746Z"
            fill="#fff"
        />
    </svg>
);

export const QRCodeSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm1 5V3h3v3H3ZM2 16a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H2Zm1 5v-3h3v3H3Zm13-1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-2ZM11 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2Zm-1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V8Zm0 9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Zm4-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2Zm6-5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2ZM1 11a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2ZM17 1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-5Zm1 5V3h3v3h-3Z"
            fill="currentColor"
        />
    </svg>
);

export const SkipperPaperSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 24 24"
        width={24}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 2C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V8H17C15.8954 8 15 7.10457 15 6V2H5ZM15.41 12.4501H17.28C17.401 12.4501 17.5 12.5491 17.5 12.6701V13.3301C17.5 13.4511 17.401 13.5501 17.28 13.5501H14.464C14.354 13.5501 14.31 13.6986 14.409 13.7536L16.851 15.1616C16.9555 15.2221 16.994 15.3596 16.9335 15.4641L16.6035 16.0361C16.543 16.1406 16.4055 16.1791 16.301 16.1186L13.859 14.7106C13.7655 14.6501 13.6555 14.7601 13.7105 14.8591L15.1185 17.301C15.179 17.4055 15.1405 17.543 15.036 17.6035L14.464 17.9335C14.3595 17.994 14.222 17.9555 14.1615 17.851L12.7535 15.4091C12.6985 15.3101 12.55 15.3541 12.55 15.4641V18.28C12.55 18.401 12.451 18.5 12.33 18.5H11.67C11.549 18.5 11.45 18.401 11.45 18.28V15.4641C11.45 15.3541 11.3015 15.3101 11.2465 15.4091L9.8385 17.851C9.778 17.9555 9.6405 17.994 9.536 17.9335L8.964 17.6035C8.8595 17.543 8.821 17.4055 8.8815 17.301L10.2895 14.8591C10.35 14.7656 10.24 14.6556 10.141 14.7106L7.699 16.1186C7.5945 16.1791 7.457 16.1406 7.3965 16.0361L7.0665 15.4641C7.006 15.3596 7.0445 15.2221 7.149 15.1616L9.591 13.7536C9.69 13.6986 9.646 13.5501 9.536 13.5501H6.72C6.599 13.5501 6.5 13.4511 6.5 13.3301V12.6701C6.5 12.5491 6.599 12.4501 6.72 12.4501H8.59C8.6505 12.4501 8.7 12.4006 8.7 12.3401V10.8002C8.7 8.96321 10.2015 7.47824 12.044 7.50024C13.859 7.52224 15.3 9.03471 15.3 10.8497V12.3401C15.3 12.4006 15.3495 12.4501 15.41 12.4501Z"
            fill="currentColor"
        />
        <path d="M16 6V2L21 7H17C16.4477 7 16 6.55228 16 6Z" fill="currentColor" />
    </svg>
);

export const UnsplashSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M22 10.884V22H2V10.884h6.295v5.58h7.366v-5.58H22ZM15.66 2H8.296v5.58h7.366V2Z"
            fill="currentColor"
        />
    </svg>
);

export const UploadSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 14V8H3l7-7 7 7h-4v6H7Zm-4 4v-2h14v2H3Z"
            fill="currentColor"
        />
    </svg>
);
